<template>
  <div class="mb-2 border-nash-midnightBlue300">
    <div class="font-medium flex items-center gap-2">
      <TIcon
        :icon="getIconName(source.sourceType, source.sourceSubtype)"
        color="nash-midnightBlue700"
      />
      {{ formatSourceHeader(source) }}
      <TIcon
        v-if="isLinkApplicable(source, patientId)"
        icon="link"
        class="cursor-pointer"
        color="nash-midnightBlue700"
        @click="navigateToTab(linkDestinationForSource(source, patientId))"
      />
    </div>
    <div class="pl-7 space-y-1">
      <div
        v-for="(quote, index) in formatQuotes(source.validatedQuotes || [])"
        :key="index"
      >
        <span class="font-semibold text-nash-neutral700"
          >{{ quote.label }}:</span
        >
        <TExpandableText :text="quote.content" :max-length="300" class="ml-1" />
      </div>
      <div
        v-if="!source.validatedQuotes"
        class="mt-2 p-2 bg-nash-midnightBlue50 rounded border border-nash-midnightBlue200"
      >
        No quote available for this source - see source for more details.
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TExpandableText from '@nashville/text/TExpandableText/TExpandableText.vue'
import TIcon from '@thyme/nashville/src/components/icon/TIcon.vue'
import { defineComponent } from 'vue'
import setup from './controller'
import { LLM_SOURCE_PROPS } from './types'

export default defineComponent({
  name: 'LlmSource',
  components: {
    TIcon,
    TExpandableText,
  },
  props: LLM_SOURCE_PROPS,
  setup,
})
</script>
